var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54741 9.94194C4.46627 9.94194 0 5.52008 0 2.39283C0 1.15799 0.771991 0 2.09052 0C2.36721 0 3.61572 2.13151 3.61572 2.39454C3.61572 2.82494 2.33647 3.45346 2.33647 3.83434C2.33647 4.76004 5.1819 7.60548 6.10761 7.60548C6.48848 7.60548 7.117 6.32623 7.54741 6.32623C7.62768 6.32623 9.85313 7.503 9.92145 7.70454C10.3928 8.80104 8.63366 9.94194 7.54741 9.94194Z",
    fill: "#DB9600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.65021b21aafdb56e6d7f3427c8e8b7f6.svg";
export { ForwardRef as ReactComponent };